export default "__VITE_ASSET__C2tHJF3J__"